module.exports = __webpack_public_path__ + "media/images/close-button-6f577d16754b7701037d887eec9388f9.svg";